import React from 'react';
import { TextLinkLayoutProps } from 'ui-builder';
import { cn } from 'shadcn-ui';

export default function ShadcnTextLinkLayout(props: TextLinkLayoutProps) {
  return (
    <a
      onClick={(event) => {
        event.preventDefault();
        if (!props.isDisabled) {
          event.stopPropagation();
          props.onClick?.();

          if (!props.onClick) {
            window.open(props.href, props.target || '_self');
          }
        }
      }}
      href={props.href}
      className={cn(
        'text-blue-500 hover:text-blue-700 cursor-pointer transition-colors',
        props.isDisabled && 'opacity-50 pointer-events-none',
        props.className,
      )}
      title={props.title}
      data-testid={props.testId}
      aria-disabled={props.isDisabled || undefined}
      tabIndex={props.isDisabled ? -1 : undefined}
    >
      {props.children}
    </a>
  );
}
